const $skip = (collection, expr, _options) => {
  return collection.drop(expr);
};
export {
  $skip
};
